import { useState } from "react";
import { useAuth } from "../../context/authContext";
import { Pencil } from "lucide-react";
import LogoUploaderModal from "./LogoUploaderModal";
import Swal from "sweetalert2";
import { changeLogo } from "../../services/companiesService";

const LogoProfile = ({ detailsCompany, isSubmitting }) => {
  const { user } = useAuth();
  const userRole = user.role;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLogo, setCurrentLogo] = useState(detailsCompany.logo);
  const handleLogoSave = async (blob) => {
    try{
      const confirmation = await Swal.fire({
        title: "¿Está seguro de que desea guardar los cambios?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, guardar",
        cancelButtonText: "Cancelar",
      });
      if (confirmation.isConfirmed) {
        const formData = new FormData();
        formData.append("logo", blob, "logo.png");
        isSubmitting(true);
        const response = await changeLogo(formData, user);
        isSubmitting(false);
        if (response.success) {
          setCurrentLogo(URL.createObjectURL(blob));
          Swal.fire("Éxito", "Logo actualizado correctamente", "success");
        }
      }
    } catch (error) {
      console.error("Error al guardar el logo:", error);
      Swal.fire("Error", "No se pudo actualizar el logo", "error");
    }
  };

  return (
    <div className="flex flex-col items-center mb-8 relative">
      <div className="relative">
        <div className="w-32 h-32 rounded-full bg-white overflow-hidden border-4 border-[#0493c4] shadow-lg">
          <img
            src={currentLogo || "/default-avatar.png"}
            alt="Logo"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <button
          onClick={() => setIsModalOpen(true)}
          className="absolute bottom-1 right-1 bg-[#0493c4] hover:bg-[#04779e] p-1 rounded-full shadow hover:bg-gray-100"
        >
          <Pencil size={20} className="text-gray-700" />
        </button>
      </div>

      <h2 className="mt-4 text-xl font-semibold text-gray-800">
        {userRole === "admin" ? "Panel Administrativo" : "Mi Cuenta"}
      </h2>

      {isModalOpen && (
        <LogoUploaderModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSave={handleLogoSave}
        />
      )}
    </div>
  );
};

export default LogoProfile;
